import React from 'react';

import { Heading, PropertyGroup } from '../../../../components';

import css from '../../../../containers/ListingPage/ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const FarmToForkDiningFeaturesWithIcons = ({ listing, listingConfig }) => {
  const featuresSelectedValues = listing.attributes.publicData.farm_to_fork_dining_features;
  const fieldConfig = listingConfig.listingFields.find(
    c => c.key === 'farm_to_fork_dining_features'
  );

  if (!featuresSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="farm_to_fork_dining_features"
        options={createFilterOptions(enumOptions)}
        selectedOptions={featuresSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default FarmToForkDiningFeaturesWithIcons;
